import React from 'react';

import Container from '../interface/Container';
import Usp from '../Usp/Usp';
import BlockWrapper from './BlockWrapper';

const UspBlock = ({ block }) => (
  <BlockWrapper grayBackground>
    <Container>
      <Usp uspData={block} />
    </Container>
  </BlockWrapper>
);

export default UspBlock;
